import OrderInfoCard from './OrderInfoCard';

export default OrderInfoCard;
